import { Box, Typography } from '@mui/material';

interface Props {
  texto?: string;
}

export function LgpdAviso({ texto }: Props): JSX.Element {
  return (
    <Box sx={{ mt: 1, mb: 2 }}>
      <Typography variant="caption" color="text.secondary">
        {texto ??
          'Seus dados são usados apenas para processar o pedido e contato pela loja. Conforme a LGPD, você pode solicitar acesso, correção ou exclusão a qualquer momento.'}
      </Typography>
    </Box>
  );
}
